import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'iposcen-ipos-help-partner-portal',
  templateUrl: './ipos-help-partner-portal.component.html',
  styleUrls: ['./ipos-help-partner-portal.component.scss']
})
export class IposHelpPartnerPortalComponent implements OnInit {
  @ViewChild('enterModelSku') enterSku: ElementRef;
  @ViewChild('createPartner') createPartner: ElementRef;
  @ViewChild('attractVideo') attractVideo: ElementRef;
  @ViewChild('packaging') packaging: ElementRef;
  @ViewChild('partnerContent') partnerContent: ElementRef;
  isEnterModelInfo = true;
  isCreatePartner = true;
  isAttractVideo = true;
  isPackaging = true;
  isPartnerChrome = true;
  constructor() { }

  ngOnInit(): void {
  }
  showDescription(data) {
    
    if(data === 'enterModel'){
      this.isEnterModelInfo = !this.isEnterModelInfo;
    }else if (data === 'createPartnerExpand'){
      this.isCreatePartner = !this.isCreatePartner;
    } else if (data === 'attractVideoExpand'){   
      this.isAttractVideo = !this.isAttractVideo;
    } else  if (data === 'packagingExpanded'){
      this.isPackaging = !this.isPackaging;
    } else if(data === 'partnerChromebook'){
      this.isPartnerChrome = !this.isPartnerChrome;
    }
  }

}
